import { render, staticRenderFns } from "./ContainerPrototypeItemList.vue?vue&type=template&id=71cce8ee&scoped=true"
import script from "./ContainerPrototypeItemList.vue?vue&type=script&lang=js"
export * from "./ContainerPrototypeItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cce8ee",
  null
  
)

export default component.exports